module.exports = __webpack_public_path__ + "img/people-icon-white.5d03528b.svg";